import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DragDropModule, CdkDragDrop } from '@angular/cdk/drag-drop';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

interface TruckConfig {
  steer: number;
  drive1?: number;
  drive2?: number;
  drive3?: number;
  drive4?: number;
  drive5?: number;
  Spare?: number;
}

@Component({
  selector: 'app-tyre-position',
  standalone: true,
  imports: [CommonModule, DragDropModule],
  templateUrl: './tyre-position.component.html',
  styleUrls: ['./tyre-position.component.css']
})
export class TyrePositionComponentDrag implements OnInit {

  // 🔥 CONFIG OPTIONS
  configOptions: { label: string; value: TruckConfig }[] = [
    { label: '4x2', value: { steer: 2, drive1: 2, Spare: 2 } },
    { label: '4x4', value: { steer: 2, drive1: 4, Spare: 2 } },
    { label: '6x2', value: { steer: 2, drive1: 2, Spare: 2 } },
    { label: '6x4', value: { steer: 2, drive1: 4, drive2: 4, Spare: 2 } },
    { label: '8x2', value: { steer: 2, drive1: 2, drive2: 2, Spare: 2 } },
    { label: '8x4', value: { steer: 2, drive1: 4, drive2: 4, drive3: 4, Spare: 2 } },
    { label: '8x8', value: { steer: 2, drive1: 4, drive2: 4, drive3: 4, drive4: 4, Spare: 2 } },
    { label: '10x4', value: { steer: 2, drive1: 4, drive2: 4, drive3: 4, drive4: 4, Spare: 2 } },
    { label: '12x6', value: { steer: 2, drive1: 4, drive2: 4, drive3: 4, drive4: 4, drive5: 4, Spare: 2 } }
  ];

  selectedConfig: TruckConfig = this.configOptions[2].value;

  tyres: any[] = [];
  truckLayout: any[] = [];
  slotMapping: Record<string, any> = {};
  connectedDropLists: string[] = [];
  @Input() data: any;
  selectedTyre: any;

  constructor(public ref: DynamicDialogRef,public config: DynamicDialogConfig){
    this.data = this.config.data
    console.log("ppppppppppppp",this.data)
    this.tyres = this.config.data?.selectedTyres


    const normalize = (val: string) =>
      val
        ?.toLowerCase()
        .replace(/×/g, 'x')   // convert × → x
        .replace(/\s+/g, '')  // remove spaces
        .trim();
        
      if (this.data && this.data.configType) {
          const found = this.configOptions.find(
            c => normalize(c.label) === normalize(this.data.configType)
          );
          console.log(found,'fond')
          if (found) {
            this.selectedConfig = found.value;
          }else{
            this.selectedConfig = this.configOptions[2].value;

          }
        }

    console.log("===========new",this.selectedConfig)

  }

  
get newTyres() {
  return this.tyres.filter(
    t => t.isNew && !this.isAssigned(t.id)
  );
}

get oldTyres() {
  return this.tyres.filter(
    t => !t.isNew && !this.isAssigned(t.id)
  );
}

isAssigned(id: number): boolean {
  return Object.values(this.slotMapping).some(
    (t: any) => t?.id === id
  );
}

  ngOnInit() {
    // this.reset();
    this.buildLayout();
     if (this.tyres) {
    this.restoreMapping(this.tyres);
  }

  }
  restoreMapping(savedData: any[]) {
    console.log(savedData,'========--')
  savedData.forEach(item => {
    const slot = item.selectedSlot;
    console.log(slot,'slot==========')
    if (this.slotMapping.hasOwnProperty(slot)) {
      this.slotMapping[slot] = item
    }
    console.log(this.slotMapping)
  });
}


  // 🔥 GENERATE TYRES
  generateTyres() {
    return [
      ...Array.from({ length: 5 }, (_, i) => ({
        id: 'N' + (i + 1),
        name: 'New Tyre ' + (i + 1),
        type: 'NEW'
      })),
      ...Array.from({ length: 5 }, (_, i) => ({
        id: 'O' + (i + 1),
        name: 'Old Tyre ' + (i + 1),
        type: 'OLD'
      }))
    ];
  }

  // 🔥 BUILD LAYOUT (TYPE SAFE)
  buildLayout() {
    this.truckLayout = [];
    this.slotMapping = {};
    this.connectedDropLists = [];

    const config = this.selectedConfig;

    const addAxle = (name: string, count: number, prefix: string) => {
      const slots: string[] = [];

      for (let i = 1; i <= count / 2; i++) {
        slots.push(`${prefix}-L${i}`, `${prefix}-R${i}`);
      }

      this.truckLayout.push({ axle: name, slots });

      slots.forEach(s => {
        this.slotMapping[s] = null;
        this.connectedDropLists.push(s);
      });
    };

    // STEER
    if (config.steer) {
      addAxle('Steer', config.steer, 'F');
    }

    // DYNAMIC DRIVES
    let driveIndex = 1;

    (Object.keys(config) as (keyof TruckConfig)[]).forEach(key => {
      if (key === 'steer') return;

      const value = config[key];
      if (!value) return;

      if (key.startsWith('drive')) {
        addAxle(`Drive${driveIndex}`, value, `R${driveIndex}`);
        driveIndex++;
      }

      if (key === 'Spare') {
        addAxle('Spare', value, 'T');
      }
    });

    this.connectedDropLists.push('newList', 'oldList');
  }

  // 🔥 CONFIG CHANGE
  onConfigChange(config: TruckConfig) {
    this.selectedConfig = config;
    // this.reset();
    this.tyres = this.config.data?.selectedTyres
    this.buildLayout();
  }

  // 🔥 DROP ON TRUCK
onDrop(event: CdkDragDrop<any>, slot: string) {
  const tyre = event.item.data;

  // ❌ restriction
  if (tyre.type === 'OLD' && slot.startsWith('F')) return;

  // 🔍 find source slot (if tyre already on truck)
  let sourceSlot: string | null = null;

  for (const key of Object.keys(this.slotMapping)) {
    if (this.slotMapping[key]?.id === tyre.id) {
      sourceSlot = key;
      break;
    }
  }

  // 🧠 CASE 1: Truck → Truck (SWAP)
  if (sourceSlot) {
    const targetTyre = this.slotMapping[slot];

    this.slotMapping[slot] = tyre;

    if (targetTyre) {
      this.slotMapping[sourceSlot] = targetTyre;
    } else {
      this.slotMapping[sourceSlot] = null;
    }

    return; // 🚨 important (list touch nahi hogi)
  }

  // 🧠 CASE 2: List → Truck

  // agar slot me already tyre hai → list me wapas bhejo
  if (this.slotMapping[slot]) {
    this.tyres.push(this.slotMapping[slot]);
  }

  // set new tyre
  this.slotMapping[slot] = tyre;

  // 🔥 IMPORTANT: list se remove
  this.tyres = this.tyres.filter(t => t.id !== tyre.id);
  console.log('thisslotMapping',this.slotMapping)
}

  // 🔥 DROP BACK TO LIST
  onDropToList(event: CdkDragDrop<any>) {
    const tyre = event.item.data;

    this.removeFromAll(tyre.id);

    if (!this.tyres.find(t => t.id === tyre.id)) {
      this.tyres.push(tyre);
    }
  }

  // 🔥 HELPERS
  removeFromAll(id: string) {
    Object.keys(this.slotMapping).forEach(k => {
      if (this.slotMapping[k]?.id === id) {
        this.slotMapping[k] = null;
      }
    });
  }

  removeFromList(id: string) {
    this.tyres = this.tyres.filter(t => t.id !== id);
  }



  // 🔥 SUBMIT
  submit() {
      // Validate
    // const payload1 = Object.keys(this.slotMapping) 
    // .filter(k => this.slotMapping[k]) 
    // .map(k => ({ 
    //   tyreId: this.slotMapping[k].id, 
    //   position: k, 
    //    }));

    const payload = Object.keys(this.slotMapping)
    .filter(k => this.slotMapping[k])
    .map(k => {
      const [axle, side] = k.split('-');
      return {
        id: this.slotMapping[k].id,
        axlePosition: this.getAxleLabel(axle),
        selectedSlot: k,
        sideSlot: this.getSideLabel(side, k)
      };
    });
    if (payload.length === 0) {
      alert('Please add at least one tyre assignment');
      return;
    }  
       // Return data
    const responseData = {
      success: true,
      responseMessage: 'Tyre assignments saved successfully',
      data: payload
    };
    console.log('FINAL PAYLOAD:', payload);
    this.ref.close(payload);
  }


getAxleLabel(axle: string): string {
  if (axle === 'F') return 'Steer Axle';
  if (axle === 'T') return 'Spare Axle';
  if (axle.startsWith('R')) {
    const num = axle.replace('R', '');
    return `Drive ${num} Axle`;
  }
  return axle;
}

getSideLabel(side: string, fullSlot: string): string {
  const isLeft = side.startsWith('L');
  const isRight = side.startsWith('R');
  if (fullSlot.startsWith('F')) {
    return isLeft
      ? `Front Left (${fullSlot})`
      : `Front Right (${fullSlot})`;
  }
  if (fullSlot.startsWith('T')) {
    return isLeft
      ? `Spare Left (${fullSlot})`
      : `Spare Right (${fullSlot})`;
  }
  // Drive
  return isLeft
    ? `Rear Left (${fullSlot})`
    : `Rear Right (${fullSlot})`;
}
  

    // 🔥 RESET
  reset() {
    // this.tyres = this.generateTyres();
    this.buildLayout();
  }

  cancel(): void {
    this.ref.close();
    this.slotMapping = {}
  }
}